import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { of } from "rxjs";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { AgenteFinanceiroService } from "src/app/shared/services/agente-financeiro.service";

@Component({
    selector: 'app-modal-cadastro-scr-associados',
    templateUrl: 'modal-cadastro-scr-associados.component.html',
    standalone: false
})
export class ModalCadastroScrAssociados implements OnInit {

  public agentesFinanceirosHabilitados: AgenteFinanceiro[];

  public formularioCadastroAssociado: UntypedFormGroup = null;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private agenteFinanceiroService: AgenteFinanceiroService,
  ) { }

  ngOnInit(): void {
    this.formularioCadastroAssociado = this.formBuilder.group({
      agenteFinanceiro: [null, Validators.required],
      cnpjAssociado: [null, Validators.required],
      nomeRazaoSocialAssociado: [null, Validators.required],

    });
    this.buscarAgentesFinanceiros();
  }

  public salvar() {
    this.activeModal.close({ botao: 'salvar', valor: this.formularioCadastroAssociado.value });

  }

  tratarCNPJCadastro() {
    var cnpj = this.formularioCadastroAssociado.get("cnpjAssociado").value;
    if (cnpj) {
      let a: string = cnpj;
      if (cnpj.length > 0 && cnpj.length < 11) {
        a = a.toUpperCase().replace(/[^0-9A-Z]+/g, '').padStart(14, '0');
      }
      this.formularioCadastroAssociado.get("cnpjAssociado").setValue(a);
    }

  }

  public cancelar() {
    this.activeModal.close({ botao: 'cancelar', valor: null });
  }

  public fechar() {
    this.activeModal.close({ botao: 'fechar', valor: null });
  }

  public buscarAgentesFinanceiros(): void {
    this.agenteFinanceiroService.getAgentesFinanceiros().subscribe((data: any) => {
      this.agentesFinanceirosHabilitados = data;
    });
  }
}